<template>
  <td>
    {{ element.elemKey }}-
    {{ configStore.getElementDefinition(element.elemKey)?.elemLongName }}
  </td>
  <td v-if="structureType === 'T'">
    {{ element.elemTag }}
  </td>
  <td class="align-center">
    {{ element.elemQuantity }}
  </td>
  <td class="align-center">
    <template v-if="isDefect(configStore.getElementDefinition(element.elemKey))">
      <!--if defect set parent uom-->
      {{
        configStore.getElementDefinition(element.elemParentKey)?.elemPairCode
      }}
    </template>
    <template v-else>
      {{
       configStore.getElementDefinition(element.elemKey)?.elemPairCode
      }}
    </template>
  </td>
  <td class="align-center">
    {{
      elementQtyGroup === ELEMENTS.QUANTITY
        ? element.elemQtyState1
        : convertToDecimalString(convertToDecimalString(element.elemPctState1, 2), 2)
    }}
  </td>
  <td class="align-center">
    {{
      elementQtyGroup === ELEMENTS.QUANTITY
        ? element.elemQtyState2
        : convertToDecimalString(convertToDecimalString(element.elemPctState2, 2), 2)
    }}
  </td>
  <td class="align-center">
    {{
      elementQtyGroup === ELEMENTS.QUANTITY
        ? element.elemQtyState3
        : convertToDecimalString(convertToDecimalString(element.elemPctState3, 2), 2)
    }}
  </td>
  <td class="align-center">
    {{
      elementQtyGroup === ELEMENTS.QUANTITY
        ? element.elemQtyState4
        : convertToDecimalString(convertToDecimalString(element.elemPctState4, 2), 2)
    }}
  </td>
</template>

<script>
import { convertToDecimalString } from "@/composables/util";
import { useConfigStore } from "@/stores/config";
import { ELEMENTS } from "@/constants/CommonWebConstants";

export default {
  name: "InspectionElementRow",
  props: ["element", "structureType", "elementQtyGroup"],
  setup() {
    const configStore = useConfigStore();

    const isDefect = (elemDef) => {
      if (elemDef?.elemProtectSys === "Y") {
        return false;
      } else if (elemDef?.elemSubComp === "Y") {
        return false;
      } else if (elemDef?.elemSmartFlag === "Y") {
        return true;
      }
    };
    return {
      convertToDecimalString,
      configStore,
      ELEMENTS,
      isDefect,
    };
  },
};
</script>
